import $ from 'jquery';
import moment from 'moment';
import ClubStore from 'framework/stores/ClubStore';
import ProfileStore from 'framework/stores/ProfileStore';
import offerService from 'framework/services/offerService';
import urlUtils from 'lib/url-utils';
import Framework from 'framework';
import _ from 'ext:lodash';
import profileStoreIsAvailable from 'lib/profile-store-utils';
import constants from 'lib/constants';

function getContent(link, element) {
	return offerService.getOffer(link)
		.then((data)=> {
			if(data) {
				element.html(data);
				// removed to not reload the content if it is already loaded
				element.removeAttr('data-action-list');
			}
		});
}

function getMembershipTypeAttribute(profile) {
	// see if there is loyalty or day pass attributes
	var memberType = 'monthly';

	if(profile.memberDetails.membershipTypeAttributes) {
		_.forEach(profile.memberDetails.membershipTypeAttributes, (type)=> {
			if(type.key === 49) {
				memberType = 'loyalty';
				return memberType;
			}else if(type.key === 51) {
				memberType = 'dayPass';
				return memberType;
			}
		});
	}

	return memberType;
}

function updateContent(profile) {
	var data = profile || ProfileStore.getInitialData();
	var clubData = ClubStore.getInitialData();

	let expirationDate = moment().subtract(30, 'days');
	let joinDate = (data && data.memberDetails && data.memberDetails.joinDate) ? moment(data.memberDetails.joinDate, moment.ISO_8601) : null;

	if(joinDate
			&& joinDate.isAfter(expirationDate)
			&& data.memberDetails
			&& data.memberDetails.membershipJoinSource === 'InternetOMS') {
		var membershipType = getMembershipTypeAttribute(data);
		// display notification to user
		createNotification(membershipType, clubData);
		// display the action list
		$('[data-action-list]').each((index, item)=> {
			var element = $(item);
			var membershipTypeElements = element.data('membership-type');
			var membershipTypeArray = membershipTypeElements.split(',');
			for(var membershipTypeElement of membershipTypeArray) {
				if(membershipTypeElement === membershipType) {
					var contentUrl = element.data('content-path');
					if(contentUrl) {
						getContent(contentUrl, element);
					}
					break;
				}
			}
		});
	}
}

function listOpenNotifications() {
	// look at what notifications are displayed on the page
	var openNotifications = $('.js-alert-notification .alert-notification').map(function() {
		var scrubbedId = this.id.replace(constants.notificationPrefix, '');
		return scrubbedId;
	}).get();

	// return a list of ids
	return openNotifications || [];
}

function createNotification(membershipType, clubData) {
	var notificationId = 'omsSuccess';
	// look for url param to see if we show notification if not already open
	var rojpParam = urlUtils.getUrlParameter('rojp');
	var openNotificationsList = listOpenNotifications();
	if(rojpParam && rojpParam === 'true' && openNotificationsList.indexOf(notificationId) < 0) {
		var message = '';
		if(clubData.status === 'presale' || clubData.status === 'waitlist') {
			message = 'Congratulations! Your membership access will begin following the Grand Opening. We look forward to seeing you in the club in the near future.';
		}else if(membershipType === 'monthly' || membershipType === 'loyalty') {
			message = 'Congratulations! Your membership is ready to use. We look forward to seeing you in the club.';
		}
		/*
		//Removed notification hotifx
		else if(membershipType === 'dayPass') {
			message = 'Congratulations! Your day pass is ready to use. We look forward to seeing you in the club.';
		}*/
		// display the notification
		if(message) {
			Framework.actions.createSuccessNotification(message, false, true, notificationId);
		}
	}
}

export default updateContent;

if (profileStoreIsAvailable) {

    updateContent();

    var unsubscribeProfile = ProfileStore.listen((profile) => {
        updateContent(profile);
        unsubscribeProfile();
    });
}
